import React from 'react';
import ReactDOM from 'react-dom';

const Portal = (props) => {
  const { children, mountNode = document.body } = props;

  if (!mountNode || !(mountNode instanceof Element)) {
    return null;
  }

  return ReactDOM.createPortal(children, mountNode);
}

export default Portal;